import React from 'react'

interface RewardsAnalyticsKPIProps {
  header: number | string
  subheader?: number | string
  description: string
}

const RewardsAnalyticsKPI: React.FC<RewardsAnalyticsKPIProps> = ({ header, subheader, description }) => {
  return (
    <div className='p-4 bg-white rounded-lg border-1 border-gray-light'>
      <div className='flex flex-row items-baseline gap-2'>
        <p className='text-[1.75rem] text-coal-dark font-semibold'>{header}</p>
        {Boolean(subheader) && <p className='text-sm text-coal-light'>{subheader}</p>}
      </div>
      <p className='text-sm text-[#949494]'>{description}</p>
    </div>
  )
}

export default React.memo(RewardsAnalyticsKPI)
